export const INTERACTION_TYPES = {
  INTERACTION: 'Interaction',
  MESSAGE: 'Message',
  SERVICE_PROVIDED: 'Service Provided',
  GENERAL: 'General',
};

export const EDITABLE_NOTE_CATEGORIES = [
  'general',
  'interaction',
  'service_provided',
];

export const NOTE_VISIBILITY = {
  PUBLIC: 'public',
  PRIVATE: 'private',
};
